import { render, staticRenderFns } from "./LayersInfo.vue?vue&type=template&id=58e613bc&scoped=true"
import script from "./LayersInfo.vue?vue&type=script&lang=js"
export * from "./LayersInfo.vue?vue&type=script&lang=js"
import style0 from "./LayersInfo.vue?vue&type=style&index=0&id=58e613bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e613bc",
  null
  
)

export default component.exports